<template>
  <el-form-item
    class="form form-select pos-relative"
    v-if="visible"
    :label="column.label"
    :prop="column.name"
    :class="[
      (column.allowCreate ? 'with-custom-label' : ''),
      `form-${fname}-${findex}-select-item-${column.name}`,
    ]">

    <template slot="label" v-if="column.hasOwnProperty('label')">
      <span
        class="inline-middle"
        :aria-label="`${ariaLabel} selection dropdown`">
        {{ column.label }}
      </span>

      <el-tooltip v-if="column.prefixInfo" effect="dark"
        placement="top"
        popper-class="tooltip-content">
        <div slot="content" v-html="column.prefixInfo.label"></div>
        <i class="header-icon el-icon-info tooltip-info-icon"></i>
      </el-tooltip>

      <span v-if="column.allowCreate" style="color:purple">
        <el-tooltip effect="dark"
          placement="top"
          popper-class="tooltip-content">
          <div slot="content" v-html="'Enter text & select dropdown to input other options.'"></div>
          <i class="header-icon el-icon-plus tooltip-info-icon" style="font-size:0.7em;margin-left:3px;"></i>
        </el-tooltip>
      </span>
    </template>

    <el-select
      class="control"
      :id="`form-select-input-wrapper-${column.name}`"
      :name="column.name"
      v-model="form[column.name]"
      :disabled="disabled || false || (!method && column.loading)"
      :placeholder="column.placeholder || ''"
      :multiple="column.multiple"
      :filterable="column.hasOwnProperty('selectFilterable') ? column.selectFilterable : true"
      :clearable="column.selectClearable || undefined"
      :autocomplete="column.selectAutocomplete || 'off'"
      :auto-complete="column.selectAutocomplete || 'off'"
      :allow-create="column.allowCreate"
      :filter-method="column.filterMethod"
      :remote="column.remote"
      :reserve-keyword="column.reserveKeyword"
      :remote-method="method"
      :loading="column.loading"
      :loading-text="column.loading ? 'loading...' : undefined"
      :teleported="false"
      :persistent="true"
      :popper-append-to-body="false"
      @focus="(info) => onEvent('focus', info)"
      @blur="(info) => onEvent('blur', info)"
      @change="(info) => onEvent('change', info)"
      @visible-change="(isVisible) => onVisibleChanged && onVisibleChanged(form, column, { isVisible })"
      style="width:100%;">
      <!-- <div slot="prefix">
        <el-tag v-if="(typeof form[column.name] === 'string' && form[column.name].length > 0)" size="small" type="primary">
          New
        </el-tag>
      </div> -->
      <el-option
        v-for="(option, oindex) in (optionsVisible || [])"
        :key="`${oindex}`"
        :value="option.id"
        :label="option.label"
        :aria-label="option.label"
        aria-selected="false"
        role="option">
        {{ option.label }}
      </el-option>
    </el-select>

    <i v-if="column.loading" class="el-icon-loading" style="position:absolute;bottom:12px;right:-16px;"></i>
  </el-form-item>
</template>

<script>
import _ from 'lodash'
import ElementHelper from '@/util/element'

// https://stackoverflow.com/questions/12374442/chrome-ignores-autocomplete-off

export default {
  name: 'form-select',
  components: {
  },
  props: ['column', 'form', 'options', 'method', 'disabled', 'fname', 'findex'],
  data () {
    return {
      visible: true,
      isMounted: false,
      isPopperVisible: false,
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },

    info: function () {
      let column = this.column
      return {
        findex: this.findex,
        ...column,
        options: this.options,
        value: this.form[column && column.name]
      }
    },

    optionsVisible: function () {
      let options = this.options
      if (options && Array.isArray(options)) {
        return _.filter(options, (item) => !item.hidden)
      }
      return []
    },

    dataWatch: function () {
      if (!this.form || !this.column || !this.column.name) {
        return undefined
      }
      return this.form[this.column.name]
    },

    ariaLabel () {
      let label = `${this.column.labelAria || this.column.label}`
      label = label.replace(/[^a-zA-Z0-9]+/g, ' ')
      return `${label}`
    },
  },
  watch: {
    'dataWatch': function (value, valueOld) {
      this.onSelectChanged(this.column, { value, valueOld })
    },

    // method: async function () {
    //   this.$set(this, 'visible', false)
    //   await this.$nextTick()
    //   this.$set(this, 'visible', true)
    // }
  },
  created () {
    // window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    // window.removeEventListener('keydown', this.keyDownHandler)
  },
  async mounted () {
    await this.onInitAccessibility()
    this.refresh()
    this.isMounted = true
  },
  methods: {
    async refresh () {
    },

    onSelectChanged (info, data) {
      // let value = this.form[this.column.name]
      // let info = _.assign({}, this.column, { value })
      info = _.assign({}, info, data)
      this.$emit('on-select-changed', info)
    },

    async onInitAccessibility () {
      await this.$nextTick()
      const column = this.column
      const id = column && column.name
      // const label = props.column?.label
      // const form = this.form
      const fname = this.fname
      const findex = this.findex

      // aria-fix:
      ElementHelper.byClass(`form-${fname}-${findex}-select-item-${id}`, document, (elem) => {
        ElementHelper.byClass('el-select__input', elem, (input) => {
          // input.setAttribute('aria-label', `${label || (id && _.startCase(id))}`)
          input.setAttribute('autocomplete', 'off')
        })
        ElementHelper.byClass('el-input__inner', elem, (input) => {
          // input.setAttribute('aria-label', `${label || (id && _.startCase(id))}`)
          input.setAttribute('autocomplete', 'off')
          input.setAttribute('aria-controls', `form-select-controls-${id}`)
          input.setAttribute('aria-expanded', `false`)
          input.setAttribute('aria-autocomplete', `none`)
          input.setAttribute('aria-haspopup', `listbox`)
          input.setAttribute('id', `form-select-${id}`)
        })
        ElementHelper.byClass(`el-popper`, elem, (popper) => {
          popper.setAttribute('tabindex', -1)
          popper.setAttribute('role', 'tooltip')
        //   ElementHelper.byClass('el-select-dropdown__list', popper, (list) => {
        //     list.setAttribute('id', `form-select-controls-${id}`)
        //     list.setAttribute('role', `listbox`)
        //     ElementHelper.byClass('el-select-dropdown__item', list, (listitem, n) => {
        //       // let optionItem = _dataOptions.value?.[n]
        //       // listitem.setAttribute('tabindex', '0')
        //       listitem.setAttribute('id', `form-select-controls-${id}-option-${n}`)
        //       listitem.setAttribute('role', 'option')
        //     })
        //   })
        })
      })
      // this.onUpdateActiveDescendent()
    },

    onUpdateListItems () {
      const column = this.column
      const id = column && column.name
      // const label = props.column?.label
      // const form = this.form
      const fname = this.fname
      const findex = this.findex

      // aria-fix:
      ElementHelper.byClass(`form-${fname}-${findex}-select-item-${id}`, document, (elem) => {
        ElementHelper.byClass(`el-popper`, elem, (popper) => {
          ElementHelper.byClass('el-select-dropdown__list', popper, (list) => {
            list.setAttribute('id', `form-select-controls-${id}`)
            list.setAttribute('role', `listbox`)
            ElementHelper.byClass('el-select-dropdown__item', list, (listitem, n) => {
              // let optionItem = _dataOptions.value?.[n]
              // listitem.setAttribute('tabindex', '0')
              listitem.setAttribute('id', `form-select-controls-${id}-option-${n}`)
              listitem.setAttribute('role', 'option')
            })
          })
        })
      })
    },

    onUpdateActiveDescendent () {
      const column = this.column
      const id = column && column.name
      const form = this.form
      const fname = this.fname
      const findex = this.findex
      ElementHelper.byClass(`form-${fname}-${findex}-select-item-${id}`, document, (elem) => {
        ElementHelper.byClass('el-input__inner', elem, (input) => {
          const getIndex = _.findIndex(this.optionsVisible, (op) => op.id === form[column.name])
          if (getIndex >= 0) {
            input.setAttribute('aria-activedescendant', `form-select-controls-${id}-option-${getIndex}`)
          } else {
            input.removeAttribute('aria-activedescendant')
          }
        })
      })
    },

    onFocusControl () {
      if (!this.isMounted) return
      const column = this.column
      const fname = this.fname
      const findex = this.findex
      ElementHelper.byClass(`form-${fname}-${findex}-select-item-${column.name}`, document, (elem) => {
        ElementHelper.byClass('el-input', elem, (input) => {
          if (input && input.focus) {
            input.focus()
          }
          // if (_inref.value != null) {
          //   console.log('-- on focus!!! ref', _inref.value)
          //   let ref: any = _inref.value
          //   ref.focus && ref.focus()
          // }
        })
        // let control = document.getElementById(`form-select-${props.column.name}`)
        // if (control) {
        //   control.focus()
        // }
      })
    },

    onPopperUpdate () {
      this.onUpdateListItems()
      this.onUpdateActiveDescendent()
      // const column = this.column
      // const id = column && column.name
      // const form = this.form
      // const fname = this.fname
      // const findex = this.findex
      // // const label = this.column?.label
      // ElementHelper.byClass(`form-${fname}-${findex}-select-item-${id}`, document, (elem) => {
      //   ElementHelper.byClass(`el-popper`, elem, (popper) => {
      //     // popper.setAttribute('tabindex', '0'
      //     ElementHelper.byClass('el-select-dropdown__list', popper, (list) => {
      //       // list.setAttribute('tabindex', '-1')
      //       // list.setAttribute('role', 'listbox')
      //       ElementHelper.byClass('el-select-dropdown__item', list, (listitem, n) => {
      //         // let optionItem = _dataOptions.value?.[n]
      //         // listitem.setAttribute('tabindex', '0')
      //         // listitem.setAttribute('role', 'button')
      //         // listitem.setAttribute('aria-label', `${optionItem?.label}`)
      //         // if (n === 0) {
      //         //   listitem.setAttribute('aria-selected', 'true')
      //         // }
      //       })
      //     })
      //   })
      // })
    },

    onEvent (type, info) {
      this.onUpdateActiveDescendent()
    },

    onVisibleChanged (data, column, extra = {}) {
      this.isPopperVisible = extra && extra.isVisible
      if (extra && extra.isVisible) {
        this.onPopperUpdate()
      } else {
        this.onFocusControl()
      }
      this.$emit('on-visible-changed', data, column, extra)
    },

    // keyDownHandler(e) {
    //   console.log('-- key handler', e.key)
    //   // Your handler code here
    // },
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-select {
  .with-custom-label {
    display: flex;
    flex-direction: column;
    // .el-form-item__label {
    //   z-index: 1;
    // }
    // .el-form-item__content {
    //   z-index: -1;
    // }
  }
}

</style>
